import { AREA_ID_FOR_WORLD } from '../game/economy';
import { tutorialId } from '../game/tutorialData';
import { WORLDS } from '../models/world';

export function worldCutsceneId(worldIndex: number, position: 'intro' | 'outro'): string {
  return `world_${worldIndex}_${position}`;
}

export function hideoutCutsceneId(roomId: string, tier: number): string {
  return `hideout_${roomId}_${tier}`;
}

export const EPILOGUE_CUTSCENE_ID = 'epilogue';

export const HIDEOUT_CUTSCENE_TIERS: readonly number[] = [1, 3];

/**
 * Every story beat an account can remember as seen: the cutscenes of the
 * chronicle plus the per-world briefing. The server drops any other id.
 */
export const KNOWN_CUTSCENE_IDS: ReadonlySet<string> = new Set([
  ...WORLDS.flatMap((world) => [
    worldCutsceneId(world.id, 'intro'),
    worldCutsceneId(world.id, 'outro'),
    tutorialId(world.id),
  ]),
  EPILOGUE_CUTSCENE_ID,
  ...Object.values(AREA_ID_FOR_WORLD).flatMap((roomId) =>
    HIDEOUT_CUTSCENE_TIERS.map((tier) => hideoutCutsceneId(roomId, tier)),
  ),
]);

export function isKnownCutsceneId(cutsceneId: string): boolean {
  return KNOWN_CUTSCENE_IDS.has(cutsceneId);
}
